module.exports = __webpack_public_path__ + "static/media/upspace-chalk-wordmark.884ae977.png";